import * as moment from 'moment';
import { Location } from '@angular/common';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';
/**
 * Modal component to select team out of available teams or found an own team and invite members.
 */
var ChallengeTutorialComponent = (function () {
    function ChallengeTutorialComponent(challengeService, location) {
        this.challengeService = challengeService;
        this.location = location;
        this.ngUnsubscribe = new Subject();
    }
    ChallengeTutorialComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.challengeService.displayedChallenge.takeUntil(this.ngUnsubscribe).subscribe(function (challenge) {
            if (challenge) {
                _this.challenge = challenge;
                // 7 days count as a week, only full weeks are counted
                _this.challengeDurationInWeeks = Math.trunc((moment(challenge.end).diff(moment(challenge.start), 'days') + 1) / 7);
            }
            _this.challenge = challenge;
        });
    };
    ChallengeTutorialComponent.prototype.closeModal = function () {
        this.location.back(); // <-- go back to previous location on cancel
    };
    /**
     * On destroy cancel active subscriptions
     */
    ChallengeTutorialComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return ChallengeTutorialComponent;
}());
export { ChallengeTutorialComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/challenge-tutorial/challenge-tutorial.component.ts.pre-build-optimizer.js